export enum OrderTypeFlag {
    All = 'All',
    DineIn = 'DineIn',
    Pickup = 'Pickup',
    Delivery = 'Delivery',
    QRDineIn = 'QRDineIn',
    QRTakeaway = 'QRTakeaway'
}
